module.exports = __webpack_public_path__ + "static/media/4_placeholder_en.ffb00419.png";